import React from "react";
import styled from "styled-components";
import { Info16Regular } from "@fluentui/react-icons";
import { useTip } from "../Tooltip/Tooltip";
import { useTooltipStore } from "../../../store/useTooltipStore";
import { usePilotageRhStore } from "../../../store/usePilotageRhStore";
import { compareHelpText } from "../../../functions/compareRefLabel";

/** Icône d'aide à côté du toggle "vs précédent" (tooltip au survol et au focus clavier) */
const CompareInfo = ({ on }) => {
    const period = usePilotageRhStore((s) => s.filters.period);
    const tip = useTip();
    const show = useTooltipStore((s) => s.show);
    const hide = useTooltipStore((s) => s.hide);
    const text = compareHelpText(period, on);

    const onFocus = (e) => {
        const r = e.currentTarget.getBoundingClientRect();
        show(text, r.left + r.width / 2, r.top - 6);
    };

    return (
        <Wrapper
            className={on ? "on" : ""}
            tabIndex={0}
            aria-label="Aide comparaison"
            {...tip(text)}
            onFocus={onFocus}
            onBlur={hide}
        >
            <Info16Regular />
        </Wrapper>
    );
};

export default CompareInfo;

const Wrapper = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
    width: 18px;
    height: 18px;
    margin: 4px 0 0 -6px;
    border-radius: 4px;
    color: var(--prh-muted-2);
    cursor: default;
    transition: color 0.12s;

    &.on {
        color: var(--prh-violet);
    }
    &:hover,
    &:focus-visible {
        color: var(--prh-violet-dark);
        outline: none;
    }
`;
